import { createDenormalizedSelector } from 'entities/selectors'
import { contentSchema } from 'wordpress/schemas'

const idSelector = (state, props) => props.id

export const postSelector = createDenormalizedSelector(idSelector, contentSchema)
